import { ArrowUpRight } from "lucide-react";
import { LANDING } from "@/constants/testIds";

const SERVICES = [
  {
    id: "private-chef",
    number: "01",
    title: "Personal Chef",
    tagline: "In-villa dining, tailored to your stay.",
    description:
      "A dedicated chef in your kitchen — daily menus built around your guests, dietary preferences, and the market's freshest catch. From plated tastings to relaxed family suppers by the pool.",
    inclusions: [
      "Custom multi-course menus",
      "Market & seafood sourcing",
      "Service, plating & clean-up",
      "Wine & rum pairings",
    ],
  },
  {
    id: "catering",
    number: "02",
    title: "Catering",
    tagline: "Yachts, birthdays and intimate beach affairs.",
    description:
      "Small-scale catering with a global palate — from sunset canapé service aboard your yacht to milestone birthdays and beachside gatherings. Vegan, vegetarian, Mediterranean, Bahamian, or something in between; Kristy builds the menu around your guests.",
    inclusions: [
      "Yacht & charter service",
      "Birthdays & anniversaries",
      "Beach & poolside affairs",
      "Cuisines: Bahamian, Mediterranean, vegan, vegetarian & more",
    ],
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid={LANDING.servicesSection}
      className="relative bg-[#EBE7DE] py-24 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="reveal flex items-center gap-3 mb-8">
          <span className="h-px w-8 bg-[#C05A44]" />
          <span className="font-mono-editorial text-[11px] text-[#C05A44]">
            02 · WHAT KRISTY OFFERS
          </span>
        </div>

        <div className="reveal flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16 md:mb-24">
          <h2 className="font-display font-light text-[#1A2B3C] leading-[1.02] text-4xl md:text-5xl lg:text-6xl tracking-tight max-w-3xl">
            Two ways to
            <br />
            <span className="italic">gather around her table.</span>
          </h2>
          <p className="font-body text-[#5C6B7A] max-w-sm text-base md:text-lg leading-relaxed">
            Every service is bespoke — thoughtful menus, sourced ingredients,
            and hospitality that feels like an old friend hosting.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#1A2B3C]/15">
          {SERVICES.map((s, idx) => (
            <article
              key={s.id}
              data-testid={`${LANDING.serviceCard}-${s.id}`}
              className="reveal group bg-[#EBE7DE] p-8 md:p-12 relative transition-colors duration-500 hover:bg-[#F4F1EA]"
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <div className="flex items-start justify-between mb-10">
                <span className="font-mono-editorial text-[11px] text-[#5C6B7A]">
                  {s.number}
                </span>
                <ArrowUpRight
                  size={22}
                  className="text-[#1A2B3C] transition-transform duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#C05A44]"
                />
              </div>

              <h3 className="font-display text-4xl md:text-5xl text-[#1A2B3C] tracking-tight mb-3">
                {s.title}
              </h3>
              <p className="font-display italic text-[#C05A44] text-lg md:text-xl mb-6">
                {s.tagline}
              </p>
              <p className="font-body text-[#5C6B7A] text-base md:text-lg leading-relaxed max-w-md">
                {s.description}
              </p>

              <ul className="mt-10 space-y-3 border-t border-[#1A2B3C]/15 pt-6">
                {s.inclusions.map((item) => (
                  <li
                    key={item}
                    className="flex items-center gap-3 font-body text-sm text-[#1A2B3C]"
                  >
                    <span className="h-px w-4 bg-[#C05A44]" />
                    {item}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
